<template>
  <LayoutTelas
    id="tela__lancamentoServico"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <LancamentoServicoCadastroForm
      ref="formServico"
      :dados="dadosServico"
      :usuario="funcionario"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import LancamentoServicoCadastroForm from './LancamentoServicoCadastroForm.vue'
import LancamentoService from '../../../services/lancamento.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'LancamentoServicoCadastro',
  components: {
    LancamentoServicoCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosServico: null,
      isLoading: false,
      funcionario: null,
      cliente: null,
    }
  },
  beforeMount() {
    this.carregarDadosUsuarioLogado()
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formServico.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },

    retornaMetodoGravacao(dados) {
      return dados._id
        ? LancamentoService.atualizar(dados)
        : LancamentoService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosServico = await LancamentoService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-atendimento-servicos' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },

    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    carregarDadosUsuarioLogado() {
      this.funcionario = this.$store.getters['autenticacao/userObj'].usuario
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__lancamentoServico {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
